module.exports = __webpack_public_path__ + "img/no-image.760a872b.jpg";